import React, { Component } from "react";
import { t } from "../../utils/i18n";
import PayButtonForm from "./PayButtonForm";
import WooCommerceApiForm from "./WooCommerceApiForm";
import WooCommercePluginForm from "./WooCommercePluginForm";
import ShopifyForm from "./ShopifyForm";
import InstacartForm from "./InstacartForm";
import CryptoRewardsForm from "./CryptoRewardsForm";
import SuccessUpdatedModal from "./SuccessUpdatedModal";
import "./index.scss";
import WidgetDoc from "./WidgetDoc/WidgetDoc";

class StoreIntegrations extends Component {
  constructor(props) {
    super(props);

    // Use the type from props.params.type, or if editing an existing integration,
    // use integration.integration_type if available
    const initialType = props.params.integration
      ? props.params.integration.integration_type
      : props.params.type;

    this.state = {
      type: initialType,
      storeInfo: null,
      loadingStoreInfo: true,
      formData: {
        currency: "USD",
      },
    };
  }

  showSuccessModal = () => {
    const successModalCont = document.querySelector(
      "#successmodal-integration-cont"
    );
    if (successModalCont) {
      successModalCont.style.display = "flex";
    }
  };

  selectType = (e) => {
    this.setState({ type: e.target.value });
  };

  render() {
    const { type, storeInfo, loadingStoreInfo } = this.state;

    const {
      params: { store_id, integration, tokens, selectedTokens, wallet_address },
    } = this.props;

    return (
      <div>
        <div id="successmodal-integration-cont">
          <SuccessUpdatedModal
            action="Updated"
            store_id={store_id}
            integration={integration}
          />
        </div>

        <form className="form">
          <div className="form-group row required">
            <label htmlFor="type" className="form-label store-new-formlabel">
              {t("store_integrations.form.integration_type")}
            </label>
            <div className="custom-select-wrapper">
              <select
                className="custom-select form-control"
                onChange={this.selectType}
                value={this.state.type}
                disabled={!!integration}
              >
                <option value="PayButton">{t("store_integrations.type.pay_button")}</option>
                <option value="WooCommerce Plugin">{t("store_integrations.type.woocommerce_plugin")}</option>
                <option value="CryptoRewards">{t("store_integrations.type.crypto_rewards")}</option>
                <option value="Payment Widget">{t("store_integrations.type.payment_widget")}</option>
              </select>
            </div>
          </div>
        </form>

        {type === "PayButton" && (
          <PayButtonForm
            store_id={store_id}
            integration={integration}
            showSuccessModal={this.showSuccessModal}
            storeInfo={storeInfo}
          />
        )}
        {type === "WooCommerce Plugin" && (
          <WooCommercePluginForm
            store_id={store_id}
            integration={integration}
            showSuccessModal={this.showSuccessModal}
            storeInfo={storeInfo}
          />
        )}
        {type === "CryptoRewards" && (
          <CryptoRewardsForm
            store_id={store_id}
            integration={integration}
            allTokens={tokens}
            selectedTokens={selectedTokens}
            showSuccessModal={this.showSuccessModal}
            storeInfo={storeInfo}
          />
        )}
        {(type === "Widget" || type === "PaymentWidget" || type === "Payment Widget") && (
          <WidgetDoc
            store_id={store_id}
            integration={integration}
            showSuccessModal={this.showSuccessModal}
            wallet_address={wallet_address}
          />
        )}
      </div>
    );
  }
}

export default StoreIntegrations;
